export const MuiPickersCalendarHeader = palette => ({
  styleOverrides: {
    switchViewButton: {
      color: palette.surface.onSurface
    }
  }
})
